import { Link } from 'react-router-dom';
import { useSession } from '@/hooks/useSession';
import { landingPath } from '@/lib/access';

export default function NotFound(): JSX.Element {
  const session = useSession();
  // La salida es la primera pantalla que el rol puede ver: ofrecerle el panel a
  // quien no lo tiene habilitado lo dejaba rebotando.
  const home = landingPath(session);

  return (
    <div className="space-y-3">
      <h1 className="text-2xl font-semibold">No encontramos esa página</h1>
      <p className="text-sm text-ink-muted">
        Verificá el enlace o volvé al inicio.
      </p>
      <Link to={home} className="text-brand hover:underline text-sm">
        Ir al inicio
      </Link>
    </div>
  );
}
